import React, { useState } from 'react';
import { Grid, TextField, Button, Card, CardContent, CircularProgress, Divider, makeStyles, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';

const useStyles = makeStyles(() => ({
  buttonSuccess: {
    backgroundColor: '#4CAF50',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#45a049',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e',
    },
  },
  content: {
    minHeight: 130,
    minWidth: 530,
    '@media (max-width:600px)': {
      minWidth: '100%',
      padding: '10px',
    },
  },
  textField: {
    width: '100%',
    '@media (max-width:600px)': {
      marginBottom: '10px',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    '@media (max-width:600px)': {
      justifyContent: 'center',
      width: '100%',
    },
  },
}));

const Follow = ({ className, ReceiptNo, tasks }) => {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const [sendNote, setSendNote] = useState('');
  const [uyariCiktiNote, setUyariCiktiNote] = useState(false);
  const [uyariAciklamaNote, setUyariAciklamaNote] = useState('');
  const [Required, setRequired] = useState(false);
  const [uyariTipCiktiNote, setUyariTipCiktiNote] = useState();
  const today = new Date();
  const isMobile = useMediaQuery('(max-width:600px)');
  const YazdirMerkezeGonderData = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));

  const sendNoteYes = (Note) => {
    if (Note.length <= 0) {
      setRequired(true);
    } else {
      const data = {
        ReceiptNo,
        Note,
        WatchListId: YazdirMerkezeGonderData[0].WatchListId,
        EmployeeId: parseInt(SessionUser.TechnicianId),
        ServiceShop: YazdirMerkezeGonderData[0].ServiceShop,
        ServiceShopId: YazdirMerkezeGonderData[0].ServiceShopId,
        MobileStatusId: YazdirMerkezeGonderData[0].MobileStatusId,
        Status: YazdirMerkezeGonderData[0].Status,
        WorkCaseId: YazdirMerkezeGonderData[0].WorkCaseId,
        CallDate: YazdirMerkezeGonderData[0].OpenDate,
        ContactName: YazdirMerkezeGonderData[0].ContactName,
        ConsumerId: YazdirMerkezeGonderData[0].ConsumerId,
        FollowDate: today,
      };
      setLoading(true);
      axios.post('/SetWatchList', data)
        .then(() => {
          setUyariAciklamaNote(t('lblNoteMessage'));
          setUyariTipCiktiNote('success');
          setUyariCiktiNote(true);
          setLoading(false);
        })
        .catch((error) => {
          setUyariAciklamaNote(error.message);
          setUyariTipCiktiNote('error');
          setUyariCiktiNote(true);
          setLoading(false);
        });
    }
  };

  return (
    <Card className={className} style={{ width: isMobile ? '90%' : 'auto', margin: 'auto' }}>
      {uyariCiktiNote && (
        <Alert onClose={() => setUyariCiktiNote(false)} open message={uyariAciklamaNote} variant={uyariTipCiktiNote} />
      )}
      <Divider />
      <CardContent className={classes.content}>
        {loading ? <CircularProgress style={{ display: 'block', margin: '0 auto' }} /> : null}
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <TextField 
              size="small"
              id="Note"
              error={sendNote.length > 0 ? false : Required}
              required
              autoComplete="no"
              value={sendNote || ''}
              onChange={(event) => setSendNote(event.target.value)}
              className={classes.textField}
              label={t('lblwriteNote')}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
                style: { backgroundColor: 'white', padding: '0 4px', transform: 'translate(14px, -6px) scale(0.75)', color: '#1D3343' },
              }}
            />
          </Grid>
          <Grid item xs={12} md={2} className={classes.buttonContainer}>
            <Button 
              className={classes.buttonSuccess}
              onClick={() => sendNoteYes(sendNote)}
              variant="contained"
              disabled={YazdirMerkezeGonderData[0]?.Follow === 1}
              fullWidth={isMobile}
            >
              {t('lblSave')}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default connect((state) => ({ tasks: state.tasks1 }))(Follow);
